import React, { Component } from 'react'

import Button from '@material-ui/core/Button'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

export default class DeleteDialog extends Component {
  render() {
    const {
      openDialog,
      closeDeleteDialog,
      elementName,
      elementGender,
      deleteItem
    } = this.props

    return (
      <Dialog
        key="dialog"
        open={openDialog}
        keepMounted
        onClose={closeDeleteDialog}
      >
        <DialogTitle>Supprimer</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Êtes-vous sûr de vouloir supprimer{' '}
            {elementGender === 'f' ? 'cette' : 'ce'} {elementName} ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDeleteDialog} color="default">
            Annuler
          </Button>
          <Button onClick={deleteItem}>Valider</Button>
        </DialogActions>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components-utils/DeleteDialog.js